//@ts-nocheck
import React from "react";
import { DropdownElement } from "components/FormGroupList/FormGroupList";
import { useRef, useState, useEffect, createRef } from "react";
//this hook handles the opening and closing of opoups/drop downs/and closing the
//dropdowns when clicking outside of them
//i give a class of ignoreClick to any element that should not close the dropdown on click.

function useClickOutside(dropdowns: DropdownElement[], user) {
	//dropdowns is an array of objects holding the title and id properties that we plug into the jsx elements.
	//we do not map the array of objects in the jsx component because it makes the page even more complicated to read so the title property
	//serves as a label for the dev to know what id is attached to what.
	//could be swayed to change my mind on the map buuuuuuuut like it feels easier this way to add more dropdowns
	//this is a nifty way to make how many refs you need that you pass into your hook
	const dropdownRefs = useRef<HTMLDivElement[]>(dropdowns.map(() => createRef<HTMLDivElement>()));
	const [openDropdownId, setOpenDropdownId] = useState<number | null>(null);
	const prevOpenDropdownIdRef = useRef(null);

	//i grab the previous id passed to check if the it equals the newest and if it does that means the button with the handleClick
	//has been pressed again so then we close it, if not- open that drop down up
	function handleClick(dropdownId) {
		if (prevOpenDropdownIdRef.current === dropdownId) {
			setOpenDropdownId(null);
			prevOpenDropdownIdRef.current = null;
		} else {
			setOpenDropdownId(dropdownId);
			prevOpenDropdownIdRef.current = dropdownId;
		}
	}

	function handleClickOutside(event) {
		dropdownRefs.current.forEach((dropdownRef, index) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				//this is the class that i give to any element that should not close the dropdown on click
				const shouldIgnoreClick = event.target.closest(".ignoreClick");
				if (shouldIgnoreClick) {
					//if a user clicks an elemnt that has the ignore class then we return so we don't close the menu
					return;
				}
				if (!shouldIgnoreClick) {
					setOpenDropdownId(null);
					//if the user clicks outside of the protected areas we close the dropdown and reset the prevOpenDropdownIdRef
					prevOpenDropdownIdRef.current = null;
				}
			}
		});
	}

	useEffect(() => {
		if (user?.hideTutorial) {
			document.addEventListener("click", handleClickOutside, true);
			return () => {
				document.removeEventListener("click", handleClickOutside, true);
			};
		}
	}, [user?.hideTutorial]);

	return {
		dropdownRefs,
		openDropdownId,
		handleClick,
		setOpenDropdownId,
	};
}

export default useClickOutside;
